/** Chip-order key for committed keyword search in `UnifiedFilterBar`. */
export const TEXT_SEARCH_CHIP_KEY = 'q'

/** Default order for URL/deep-link loads: layout order for filters, keyword last. */
export function buildDefaultChipOrder(
  showTextSearch: boolean,
  appliedFilterKeys: string[],
  layoutOrderedKeys: string[],
): string[] {
  const order: string[] = []
  for (const key of layoutOrderedKeys) {
    if (appliedFilterKeys.includes(key)) order.push(key)
  }
  for (const key of appliedFilterKeys) {
    if (!order.includes(key)) order.push(key)
  }
  if (showTextSearch) order.push(TEXT_SEARCH_CHIP_KEY)
  return order
}

/** Drop removed chips; append externally activated ones at the end. */
export function reconcileChipOrder(
  prev: string[],
  showTextSearch: boolean,
  appliedFilterKeys: string[],
): string[] {
  const active = new Set([
    ...(showTextSearch ? [TEXT_SEARCH_CHIP_KEY] : []),
    ...appliedFilterKeys,
  ])
  const next = prev.filter((key) => active.has(key))
  let changed = next.length !== prev.length

  for (const key of appliedFilterKeys) {
    if (!next.includes(key)) {
      next.push(key)
      changed = true
    }
  }
  if (showTextSearch && !next.includes(TEXT_SEARCH_CHIP_KEY)) {
    next.push(TEXT_SEARCH_CHIP_KEY)
    changed = true
  }

  return changed ? next : prev
}

export function appendChipKey(order: string[], key: string): string[] {
  return order.includes(key) ? order : [...order, key]
}

export function removeChipKey(order: string[], key: string): string[] {
  return order.filter((entry) => entry !== key)
}

/** Visible chips in application order (`chipOrder`), not menu layout order. */
export function visibleChipOrder(
  chipOrder: string[],
  showTextSearch: boolean,
  appliedFilterKeys: string[],
): string[] {
  const appliedSet = new Set(appliedFilterKeys)
  return chipOrder.filter((key) =>
    key === TEXT_SEARCH_CHIP_KEY ? showTextSearch : appliedSet.has(key),
  )
}
